<template>
  <div
    class="dots_menu"
    @mouseleave="hover = false"
    @mouseover="hover = true"
  >
    <span class="dot" />
    <span class="dot" />
    <span class="dot" />
    <transition name="fade">
      <ul
        v-show="hover"
        class="select_dropdown"
      >
        <li>
          <a
            href="javascript:;"
            @click="openModal({ modal: widget.type, widget: widget, pageId: pageId}); hover = false;"
          >
            <i class="edit_icon" />
            <span>Edit</span>
          </a>
        </li>
        <li>
          <a
            href="javascript:;"
            @click="toggleFreeze()"
          >
            <span style="font-size: 14px; width: 18px; margin-right: 0.5rem;">
              <i class="fas fa-snowflake" />
            </span>
            <span>{{ widget.frozen ? 'Unfreeze Data' : 'Freeze Data' }}</span>
          </a>
        </li>
        <!--<li>
            <a href="javascript:;" @click="duplicateWidget()">
                <i class="copy_icon"></i>
                <span>Duplicate</span>
            </a>
        </li>-->
        <li>
          <hr>
        </li>
        <li>
          <a
            href="javascript:;"
            @click="handleDeleteWidget"
          >
            <i class="delete_icon" />
            <span>Delete</span>
          </a>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import _ from 'lodash';

export default {
  props: {
    widget: {
      type: Object,
      required: true
    },
    pageId: {
      type: Number,
      required: true
    }
  },
  emits: ['refresh'],
  data() {
    return {
      hover: false
    }
  },
  computed: {
    ...mapState('report', ['report'])
  },
  methods: {
    ...mapActions('widgetModal', ['openModal']),
    ...mapActions('pages', ['addWidget', 'deleteWidget', 'updateWidget']),
    toggleFreeze() {
      window.mixpanel('Report Builder: Freeze report widget data', {
        report_id: this.report.id,
        widget_id: this.widget.id
      });

      //TODO: fix mutating prop
      // eslint-disable-next-line vue/no-mutating-props
      this.widget.frozen = !this.widget.frozen;
      this.updateWidget({widget: this.widget, pageId: this.pageId});
      this.$emit('refresh', this.widget);
    },
    async duplicateWidget() {
      // TODO: Why is this not working?
      let widgetCopy = _.cloneDeep(this.widget);
      widgetCopy.id = `widget-${widgetCopy.type}-${Date.now()}`;
      widgetCopy.content = `<div id="${widgetCopy.id}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`;
      delete widgetCopy.x;
      delete widgetCopy.y;
      delete widgetCopy.resized;
      await this.addWidget({widget: widgetCopy, pageId: this.pageId})
    },
    async handleDeleteWidget() {
      await window.mixpanel('Report Builder: Delete report widget', {
        report_id: this.report.id,
        widget_id: this.widget.id
      });

      await this.deleteWidget({widget: this.widget, pageId: this.pageId})
      this.hover = false;
    },
  }
}
</script>

<style scoped>
.dots_menu {
  visibility: hidden;
  width: 30px;
  height: 15px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 10px;
  background-color: rgba(255, 255, 255);
  padding: 2px 5px;
  border-radius: 0.75rem;
  border: solid 1px #C7C4C1;
}

.dots_menu:before {
  position: absolute;
  content: "";
  width: 20px;
  height: 15px;
  left: -6px;
}

.dots_menu:hover:before {
  position: absolute;
  content: "";
  width: 215px;
  left: -198px;
  height: 50px;
}

.dots_menu:hover .dot:nth-child(1) {
  -webkit-animation: swing 0.2s forwards;
  animation: swing 0.2s forwards;
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}

.dots_menu:hover .dot:nth-child(2) {
  -webkit-animation: swing 0.2s forwards;
  animation: swing 0.2s forwards;
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}

.dots_menu:hover .dot:nth-child(3) {
  -webkit-animation: swing 0.2s forwards;
  animation: swing 0.2s forwards;
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

.dot {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  background: #231F20;
  opacity: 0.3;
  top: 0;
  position: relative;
}

.select_dropdown {
  right: -1rem;
  left: auto;
  bottom: -1rem;
  margin: 10px;
  z-index: 101;
  position: absolute;
  width: 215px;
  -webkit-transform: translateY(100%);
  -ms-transform: translateY(100%);
  transform: translateY(100%);
  padding: 1rem;
  background-color: white;
  border: 1px solid #C7C4C1;
  border-radius: .75rem;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.select_dropdown li a {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.select_dropdown li hr {
  margin: 0.5rem 0;
}

.select_dropdown li a i {
  margin-right: 0.5rem;
}

.select_dropdown li a span i {
  margin-right: 0;
}

.select_dropdown li:last-of-type a {
  color: #F34F4F;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>
